export default {
    path: 'sales_manage',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/salesManage/list'),
	redirect:'/sales_manage/register',
    meta: {title:'销售管理'},
	children: [{
			path: '/sales_manage/register',
			component: () => import('@/pages/salesManage/register'),
			meta: {
				title: '注册链接'
			},
		},
		{
			path: '/sales_manage/shareRecord',
			component: () => import('@/pages/salesManage/shareRecord'),
			meta: {
				title: '分享记录'
			},
		}
	]
}